import { TranslationService } from '../../../services/translation.service';
import { TimeMode } from './time-mode.enum';

function getTranslationText(type: TimeMode, shortText = false): string {
  let text = '';
  if (type === TimeMode.now && !shortText) {
    text = TranslationService.get('common.selectnowtime');
  } else if (type === TimeMode.now && shortText) {
    text = TranslationService.get('common.now');
  } else if (type === TimeMode.departure) {
    text = TranslationService.get('common.selectdeparturetime');
  } else if (type === TimeMode.arrival) {
    text = TranslationService.get('common.selectarrivaltime');
  }
  return text;
}

function TimeModeSelector({
  id,
  availableTimeModes = [TimeMode.now, TimeMode.departure, TimeMode.arrival],
  selectedTimeMode,
  legend,
  onChange,
}: {
  id: string;
  availableTimeModes?: TimeMode[];
  selectedTimeMode: TimeMode;
  legend?: string;
  onChange?: ((timeMode: TimeMode) => void) | undefined;
}) {
  return (
    <fieldset id={id} className="d-flex flex-wrap p-0 w-100 align-items-center">
      <legend>{legend ?? TranslationService.get('common.timeselectionlegend')}</legend>
      {availableTimeModes.map((availableTimeMode) => (
        <div className="form-check me-4 my-1 d-none d-sm-block" key={availableTimeMode}>
          <input
            type="radio"
            className="form-check-input"
            name={`${id}-input`}
            id={`${id}-input-${availableTimeMode}`}
            checked={availableTimeMode === selectedTimeMode}
            onChange={() => {
              onChange?.(availableTimeMode);
            }}
          />
          <label className="form-check-label fw-normal" htmlFor={`${id}-input-${availableTimeMode}`}>
            {getTranslationText(availableTimeMode)}
          </label>
        </div>
      ))}
      <select
        id={`${id}-select`}
        className="form-select d-sm-none"
        value={selectedTimeMode}
        onChange={(e) => onChange?.(e.target.value as TimeMode)}
        aria-label={TranslationService.get('common.timetypeselect')}
      >
        {availableTimeModes.map((availableTimeMode) => (
          <option id={`${id}-select-${availableTimeMode}`} key={availableTimeMode} value={availableTimeMode}>
            {getTranslationText(availableTimeMode)}
          </option>
        ))}
      </select>
    </fieldset>
  );
}

export default TimeModeSelector;
